export default "__VITE_ASSET__C1$KXJ8J__"